import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from '@app/routes/router';
import { AppProviders } from '@app/providers/AppProviders';
import { config } from '@shared/config';
import './index.css';

async function bootstrap() {
  const mockEnabled = config.mockEnabled;
  const forceAllBackend = config.forceAllBackend;

  // MSW starts in full-mock mode and hybrid mode (mock fallback for non-registered endpoints).
  // Only skipped when all traffic is forced to the backend.
  if (mockEnabled || !forceAllBackend) {
    const { worker } = await import('@mocks/msw/browser');
    await worker.start({ onUnhandledRequest: 'warn' });
  }

  if (mockEnabled) {
    // Start mock SignalR hub for real-time event simulation
    const { MockSignalRHub } = await import('@mocks/signalr/mockHub');
    const { setSignalRInstance } = await import('@api/client/signalRInstance');
    const hub = new MockSignalRHub();
    setSignalRInstance(hub);
    await hub.start();
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </StrictMode>,
  );
}

bootstrap();
